var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncentivesReceived(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.61 30.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2578f6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_567"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    className: "cls-1",
    d: "M12.27,8.92l-.63,3.68c-.05.29.15.57.44.62.11.02.23,0,.34-.05l3.31-1.74,3.31,1.74c.26.14.58.04.72-.22.06-.1.07-.22.05-.34l-.63-3.68,2.67-2.61c.21-.21.22-.54.01-.76-.08-.08-.19-.14-.31-.16l-3.7-.54-1.65-3.35c-.13-.26-.45-.37-.72-.24-.1.05-.19.14-.24.24l-1.65,3.35-3.7.54c-.29.04-.5.31-.46.6.02.12.07.23.16.31l2.68,2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    className: "cls-1",
    d: "M15.72,13.43h0c.29,0,.53.24.53.53h0v1.28c0,.29-.24.53-.53.53-.29,0-.53-.24-.53-.53v-1.28c0-.29.24-.53.53-.53h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    className: "cls-1",
    d: "M21.29,9.39c-.09.28.06.58.34.67,0,0,0,0,0,0l1.22.4c.28.1.58-.04.69-.31.1-.28-.04-.58-.31-.69l-.05-.02-1.22-.4c-.28-.09-.58.06-.67.34,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    className: "cls-1",
    d: "M19.16,2.83c.24.17.57.12.75-.12h0l.75-1.03c.17-.24.12-.57-.11-.74,0,0,0,0,0,0h0c-.24-.17-.57-.12-.74.12,0,0,0,0,0,0h0l-.75,1.04c-.17.24-.12.57.12.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    className: "cls-1",
    d: "M11.53,2.72c.17.24.51.29.74.12,0,0,0,0,0,0h0c.24-.17.29-.51.12-.74,0,0,0,0,0,0h0l-.75-1.03c-.17-.24-.5-.29-.74-.12,0,0,0,0,0,0h0c-.24.17-.29.51-.12.74,0,0,0,0,0,0h0l.75,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    className: "cls-1",
    d: "M8.59,10.45l1.21-.4c.28-.09.43-.39.34-.67s-.39-.43-.67-.34l-1.22.39c-.28.09-.44.39-.35.67.08.27.36.43.64.36h.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    className: "cls-1",
    d: "M22.36,17.03l-4.49,2.59,1.97.72,4.71-2.72c-.44-.77-1.42-1.03-2.19-.59,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    className: "cls-1",
    d: "M21.91,21.98c.03.07.04.14.07.21l5.06-2.92c.08-.04.16-.08.24-.11v-.02c-.45-.77-1.43-1.03-2.2-.59,0,0,0,0,0,0h0l-4.07,2.35c.39.28.7.65.89,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    className: "cls-1",
    d: "M29.8,20.85c-.4-.79-1.36-1.1-2.15-.7,0,0,0,0,0,0-.02.01-.05.03-.08.04l-5.47,3.16c-.03.26-.09.51-.18.74-.59,1.32-2.11,1.95-3.46,1.43l-5.12-1.87c-.28-.08-.45-.37-.37-.66.08-.28.37-.45.66-.37.03,0,.05.02.08.03l5.12,1.87c.82.32,1.74-.05,2.11-.85.35-.81-.03-1.75-.84-2.1l-.08-.03-4.18-1.52c-.55-.21-1.05-.55-1.46-.98-.99-.99-2.33-1.55-3.73-1.55-1.31,0-2.59.35-3.72,1l-5,2.89c-.26.15-.35.47-.2.73,0,0,0,0,0,0l4.21,7.29c.15.26.47.35.73.2,0,0,0,0,0,0l3.48-2.01,5.97,1.52c1.08.28,2.22.12,3.19-.44l9.8-5.66c.77-.42,1.08-1.37.71-2.17Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncentivesReceived);
export default __webpack_public_path__ + "static/media/Incentives Received.4097f729e689a2103a7a7e5aaa9bf1f1.svg";
export { ForwardRef as ReactComponent };